import React, { useEffect } from 'react';
import { protocolo_item, protocolo2_item } from '../../json/ProtocoloCeroItem';
import './ProtocoloCero.css';

const ProtocolCero = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <h3 className='title'>Protocolo Cero</h3>
                <hr className='hr-gob' />
                <h6>El Protocolo Cero establece medidas especificas para prevenir conductas de acoso sexual y/o laboral
                    y hostigamiento sexual y/o laboral en las Dependencias y Entidades de la Administración Pública Estatal,
                    así como promover una cultura institucional de igualdad de género y un clima laboral libre de violencia.
                </h6>
            </div>
            <div className='row'>
                {
                    protocolo_item.map((item, index) => (
                        <div key={index} className='col-md-2 col-4'>
                            <div className='card'>
                                <img src={"../assets/imgs/" + item.icono} className='card-img-top_protocolo' alt='' />
                             
                                <div className='d-grip gap-2 d-md-block'>
                                    <a href={item.url} className='btn_protocolo'>Ver más</a>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div className='row'>
                <h3 className='title'>Informe Anual de Resultados</h3>
                <hr className='hr-gob' />
                <h6>Informe Anual de Resultados que contiene las acciones implementadas por la Oficialía Mayor a fin
                    prevenir y atender las conductas de Acoso Sexual y/o Laboral y hostigamiento Sexual y/o Laboral
                </h6>
            </div>
            <div className='row'>
                {
                    protocolo2_item.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='card'>
                                <img src={"/assets/imgs/" + item.icono} className='card-img-top_protocolo' alt='' />
                                <div className='d-grip gap-2 d-md-block'>
                                    <a href={item.url} className='btn_protocolo'>Ver más</a>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ProtocolCero